<template>
    <div class="clock">
        <h2>{{ time }}</h2>
        <h3>{{ date }}</h3>
    </div>
</template>

<script setup>
    import { computed, onMounted, onUnmounted, ref } from 'vue'

    const now  = ref(new Date())
    const time = computed(() => now.value.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }))
    const date = computed(() => now.value.toLocaleString('fr-FR', { day: 'numeric', month: 'long', weekday: 'long' }))

    let intervalId = null

    onMounted(() => {
        intervalId = setInterval(() => {
            now.value = new Date()
        }, 1000)
    })
    
    onUnmounted(() => {
        clearInterval(intervalId)
    })
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Coiny&display=swap');

.clock {
    color: $dark-blue;
    text-transform: uppercase;

    width: 100%;

    h2, h3 {
        line-height: 1;
        margin: 0;
    }

    h2 {
        font-family: "Coiny", system-ui;
        font-size: 6vw;
        font-style: normal;
        font-weight: 400;
    }

    h3 {
        font-size: 1.8vw;
        font-weight: normal;
    }
}
</style>